<template>
    <!-- <v-navigation-drawer absolute bottom temporary dense app v-model="esVisible"> -->
    <!-- <v-navigation-drawer absolute clipped dense expand-on-hover bottom disable-resize-watcher v-model="esVisible"> -->
    <v-navigation-drawer app temporary dense disable-resize-watcher v-model="esVisible">
        <v-list>
          <v-list-item class="px-2">
            <v-list-item-avatar>
              <v-img src="../assets/venado-avatar.png"></v-img>
            </v-list-item-avatar>
          </v-list-item>

        </v-list>

      <v-divider></v-divider>

        <v-list nav dense>

          <v-list-item link @click="Perfil">
            <v-list-item-icon>
              <v-icon color="blue">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title >Mi perfil</v-list-item-title>
          </v-list-item>         


          <v-divider></v-divider>
          <b>Trámites</b>

          <v-list-item link to="/ComiteAcademico">
            <v-list-item-icon>
              <v-icon color="green">mdi-human-capacity-increase</v-icon>
            </v-list-item-icon>
            <v-list-item-title >Comité Académico</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="About">
            <v-list-item-icon>
              <v-icon color="green">mdi-transit-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-title >Traslado Estudiantil</v-list-item-title>
          </v-list-item>

          <v-list-item link>
            <v-list-item-icon>
              <v-icon color="green">mdi-compass</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Cambio de carrera</v-list-item-title>
          </v-list-item>

          <v-list-item link>
            <v-list-item-icon>
              <v-icon color="green">mdi-bank-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Movilidad</v-list-item-title>
          </v-list-item>

          <v-list-item link>
            <v-list-item-icon>
              <v-icon color="green">mdi-calendar-check</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Actividad complementaria</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item link @click="Estatus">
            <v-list-item-icon>
              <v-icon color="black">mdi-list-status</v-icon>
            </v-list-item-icon>
            <v-list-item-title >Estatus de trámites</v-list-item-title>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>
</template>


<script>
export default {
    name: 'MenuLateral',
     props:{
      value: Boolean
    },   
    data() {
        return {
            esVisible: this.value,
            
            nombre: "Fredy",
            apellido: "Ponce",
            correo: "fredyitp@gmail.com",
        }
    },   

    watch:{
      value: function(){
        this.esVisible = this.value
      },
      esVisible: function() {
        this.$emit('cerrar', this.esVisible)
      }  

    },


    methods: {
        Perfil(){
          this.$router.push({name: 'PerfilAlumno'})
        },
        About(){
          this.$router.push({name: 'SolicitudTraslado'})
        },
        Estatus(){
          this.$router.push({name: 'EstatusTramites'})
        }
    },
}
</script>
